function readRequiredEnvironmentValue(environmentValue: string, environmentKey: string): string {
  const trimmedValue = environmentValue === undefined ? '' : environmentValue.trim();
  if (trimmedValue.length === 0) {
    throw new Error('Missing required environment variable: ' + environmentKey);
  }
  return trimmedValue;
}

function parseIntegerEnvironmentValue(environmentValue: string, fallbackValue: number): number {
  const parsedValue = Number.parseInt(environmentValue, 10);
  if (Number.isNaN(parsedValue)) {
    return fallbackValue;
  }
  return parsedValue;
}

function readOptionalEnvironmentValue(environmentValue: string, fallbackValue: string): string {
  const trimmedValue = environmentValue === undefined ? '' : environmentValue.trim();
  return trimmedValue.length === 0 ? fallbackValue : trimmedValue;
}

export const environment = {
  apiBaseUrl: readRequiredEnvironmentValue(import.meta.env.VITE_API_BASE_URL, 'VITE_API_BASE_URL'),
  apiTimeoutMilliseconds: parseIntegerEnvironmentValue(
    import.meta.env.VITE_API_TIMEOUT_MILLISECONDS,
    15000
  ),
  brandName: readRequiredEnvironmentValue(import.meta.env.VITE_BRAND_NAME, 'VITE_BRAND_NAME'),
  brandLogoUrl: readOptionalEnvironmentValue(import.meta.env.VITE_BRAND_LOGO_URL, ''),
  platformUrl: readOptionalEnvironmentValue(import.meta.env.VITE_PLATFORM_URL, ''),
  googleReviewUrl: readRequiredEnvironmentValue(
    import.meta.env.VITE_GOOGLE_REVIEW_URL,
    'VITE_GOOGLE_REVIEW_URL'
  ),
  defaultLocale: readRequiredEnvironmentValue(
    import.meta.env.VITE_DEFAULT_LOCALE,
    'VITE_DEFAULT_LOCALE'
  ),
  defaultPhoneCountry: readOptionalEnvironmentValue(
    import.meta.env.VITE_DEFAULT_PHONE_COUNTRY,
    'PL'
  ),
} as const;
